import script from "./BasePhone.vue?vue&type=script&setup=true&lang=js"
export * from "./BasePhone.vue?vue&type=script&setup=true&lang=js"

import "./BasePhone.vue?vue&type=style&index=0&id=ab49aaf6&lang=scss"

const __exports__ = script;

export default __exports__